import SkillAndExpertiseCard from "./SkillAndExpertiseCard";

export default SkillAndExpertiseCard;
